import Qs from 'qs'

import { createAuthedHttpClient } from '@driftt/web-auth'
import config from 'config'

export const DriftAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.DRIFT_API,
    paramsSerializer: params => Qs.stringify(params, { arrayFormat: 'repeat' }),
  }
})

export const CustomerAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CUSTOMER_API,
    paramsSerializer: params => Qs.stringify(params, { arrayFormat: 'repeat' }),
  }
})

export const ConversationAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CONVERSATION_API,
    paramsSerializer: params => Qs.stringify(params, { arrayFormat: 'repeat' })
  }
})

export const AccountsAPI = createAuthedHttpClient({ baseConfig: { baseURL: config.ACCOUNTS_API } })

export const SyncAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.SYNCJOB_API,
    paramsSerializer: params => Qs.stringify(params, { arrayFormat: 'repeat' })
  }
})

export const IntegrationAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.INTEGRATION_API,
    paramsSerializer: params => Qs.stringify(params, { arrayFormat: 'repeat' })
  }
})

export const ContactsAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CONTACTS_API,
    paramsSerializer: params => Qs.stringify(params, { arrayFormat: 'repeat' }),
  }
})

export const ContactsMergerAPI = createAuthedHttpClient({ baseConfig: { baseURL: config.CONTACTS_MERGER_API } })
